import { ThemeSchemaResponse } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useFlags } from '~/stores/use-flags/useFlags';
import { ThemeLogoIcon } from '~/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';

import styles from './ThemeHeaderDetailed.module.scss';

export interface ThemeHeaderDetailedProps {
  theme: Pick<ThemeSchemaResponse, 'logo_url' | 'name' | 'description'>;
  title?: string;
}

export const ThemeHeaderDetailed = ({
  theme,
  title,
}: ThemeHeaderDetailedProps) => {
  const { t } = useTranslation(['widget']);
  const intradayThemePerfV2Enabled = useFlags(state =>
    state.getFeatureFlagState('intraday_theme_perf_v2')
  );
  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <ThemeLogoIcon logo_url={theme.logo_url} name={theme.name} />
        <span>
          <div className={styles.titleText}>{title ?? theme.name}</div>
          <div className={styles.subtitleSmall}>
            {t('assetOverview.knowledgeGraph.themeExposure.investmentTheme')}
          </div>
        </span>
      </div>
      {intradayThemePerfV2Enabled ? null : (
        <div className={styles.bodySmall}>{theme.description}</div>
      )}
    </div>
  );
};
